var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxsPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6089 21.4251L20.5276 16.8051C20.2874 16.5867 19.9718 16.4703 19.6474 16.4803C19.3229 16.4904 19.0151 16.6261 18.7889 16.8588L15.7976 19.9351C15.0776 19.7976 13.6301 19.3463 12.1401 17.8601C10.6501 16.3688 10.1989 14.9176 10.0651 14.2026L13.1389 11.2101C13.3719 10.984 13.5078 10.6761 13.5178 10.3516C13.5278 10.027 13.4112 9.71136 13.1926 9.4713L8.57386 4.3913C8.35516 4.1505 8.05121 4.00443 7.72655 3.98413C7.40189 3.96382 7.08211 4.07088 6.83511 4.28255L4.12261 6.6088C3.9065 6.8257 3.77751 7.11437 3.76011 7.42005C3.74136 7.73255 3.38386 15.1351 9.12386 20.8776C14.1314 25.8838 20.4039 26.2501 22.1314 26.2501C22.3839 26.2501 22.5389 26.2426 22.5801 26.2401C22.8858 26.2229 23.1743 26.0934 23.3901 25.8763L25.7151 23.1626C25.9276 22.9163 26.0355 22.5968 26.0156 22.2722C25.9958 21.9475 25.8498 21.6435 25.6089 21.4251V21.4251Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsPhone);
export default __webpack_public_path__ + "static/media/bxs_phone.2e6a734c81ff4fee7bc8c3a8385c8ff0.svg";
export { ForwardRef as ReactComponent };